import { Component } from '@angular/core';

@Component({
  selector: 'app-how-to',
  standalone: true,
  templateUrl: './how-to.component.html',
  styleUrls: ['./how-to.component.css'],
})
export class HowToComponent {}
